import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'

interface AccountingTooltipProps {
  openLeft: boolean
  hideMdUp?: boolean
  hideSmDown?: boolean
}

const AccountingTooltip: React.FC<AccountingTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip
      openLeft={props.openLeft}
      hideMdUp={props.hideMdUp}
      hideSmDown={props.hideSmDown}
    >
      <p>
        <Trns
          source={
            'Accounting data is used to track spending and reconcile expenses. This data includes Expense Categories to organize transactions, and attachments, such as receipts or invoices.'
          }
        />
      </p>
    </Tooltip>
  )
}

export default AccountingTooltip
